import { render, staticRenderFns } from "./LBR.vue?vue&type=template&id=40a684f4&scoped=true&"
import script from "./LBR.vue?vue&type=script&lang=js&"
export * from "./LBR.vue?vue&type=script&lang=js&"
import style0 from "./LBR.vue?vue&type=style&index=0&id=40a684f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a684f4",
  null
  
)

export default component.exports